import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-troy-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-troy-ny", statusCode: 301 });
  },
});
